import React from 'react';
import Component from '../../components/Component';
import DbInfo from '../../dbinfo';
import * as Constants from '../../constants';
import Toolbar from '../../components/Toolbar';
import {Button} from 'react-bootstrap';
import {RxForm, FormManager, FormField, FormRow, Multiform} from 'reactis-forms';
import {TextInput, TextArea, DatePicker, RadioList, FileUpload, ImageUpload, Select, Checkbox, Number} from 'reactis-inputs';
import {actions as formactions} from 'reactis-forms';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {AlertWindow, ConfirmWindow} from 'reactis-modal';
import FormDB from '../../components/FormDB';
import {Loader, LoadingButton} from 'reactis-loader';
import ActionButton from '../../components/ActionButton';
import SaveButton from '../../components/SaveButton';
import ButtonToolbar from '../../components/ButtonToolbar';
import IconCheckbox from "../../components/Form/IconCheckbox";

@connect((state, props) => {
		return {
			form: state.forms.get('tab_' + props.tabid)
		};
	},
	(dispatch) => {
		return {actions: bindActionCreators(formactions, dispatch)};
	}, null, {withRef: true })
export default class Form extends FormDB {

	constructor(props, context) {
		super(props, context);

		this.api = {
			fetch: 'trainingtext.fetch',
			save: 'trainingtext.save',
			remove: 'trainingtext.delete'
		};

		this.changeEvent = 'trainingtext.change';

		this.messages = {
			remove: 'Opravdu si přejete text odstranit?',
			notfound: 'Text nenalezen!'
		};

		this.schema = {
			text: {
				class: TextArea,
				label: 'Text',
				autoFocus: !props.id,
				style: {
					height: 140
				},
				rules: {
					presence: {message: 'Text je povinná položka!'}
				}
			}
		};
		this.form = new FormManager(this.schema);
	}

	componentDidMount() {
		this.form.on('change', (key, value) => {
			if (key == 'text') {
				this.title = value;
			}
			this.changed = true;
		});
		super.componentDidMount();
	}

	updateTab(data) {
		this.props.updateTab({title: data.text});
	}

	render() {

		const loading = !!(this.props.form && this.props.form.get('saving'));
		const canEdit = true || this.user.isAllowed('user', 'update');
		const canDelete = true || this.user.isAllowed('user', 'delete');
		const isNew = !this.props.id;

		const saveCloseButton = <LoadingButton
			disabled={!canEdit}
			title="Uložit"
			loading={loading}
			onClick={()=>this.save(true)}
		/>;

		const toolbar = [
			{
				title: 'Uložit',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'primary',
				onClick: () => this.save(true)
			},
			{
				title: 'Uložit a pokračovat v editaci',
				icon: 'fa fa-check',
				loading: loading,
				bsStyle: 'default',
				onClick: () => this.save()
			},
			{
				title: 'Uložit a nový',
				icon: 'fa fa-file-o',
				loading: loading,
				bsStyle: 'default',
				onClick: ()=>this.save(true, false, {}, () => this.props.newTab())
			},
			{
				divider: true
			},
			{
				title: 'Odstranit',
				icon: 'fa fa-trash-o',
				bsStyle: 'danger',
				color: '#A00',
				onClick: ()=>this.remove()
			}
		];

		return (
			<div style={{position:'relative'}}>
				<Loader visible={!!(this.props.form && this.props.form.get('loading'))} />
				<RxForm ref="form" form={this.form} id={'tab_' + this.props.tabid}>
					<Toolbar title="Text do protokolu">
						<ButtonToolbar buttons={toolbar} />
					</Toolbar>
					<div className="row">
						<div>
							<table className="form">
								<tbody>
								{Object.keys(this.schema).map((key) => {
									return <FormRow key={key} visible={this.schema[key].visible} name={key} labelWidth={180}/>
								})}
								<FormRow className="buttons">
									{saveCloseButton}
								</FormRow>
								</tbody>
							</table>
						</div>
					</div>
				</RxForm>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/containers/Trainingtext/Form.js